<template>
   <div class="confirm-order-wrapper">

       <div class="confirm-order-top">
           <!-- top返回 -->
            <MovieGoBack :text="text" :style="{'background':'transparent'}"></MovieGoBack>

           <!-- 购票信息 -->
            <div class="order-detail-wrapper">
                <div class="title">
                    <h1>你好，李焕英</h1>
                    <div class="time">还剩：</div>
                </div>
                <p>明天07.18 13：5-15：15(英文3D)</p>
                <p>劲松电影院(劲松店)</p>
                <p>3号激光厅 3排4座 3排5座</p>
            </div>
       </div>

        <div class="movie-box confirm-order-content">
            <div class="movie-wrapper bg-white movie-address">
                <span class="not-support"><span class="page-text-center page-inline-block not">✖</span>不支持退票</span>
                <span class="not-support"><span class="page-text-center page-inline-block not">✖</span>不支持改签</span>
            </div>

            <div class="movie-wrapper bg-white movie-address">
                <p class="order-title">劲松电影院</p>
                <p class="order-info">北京市朝阳区劲松中街404楼</p>
            </div>

            <!-- <div class="movie-wrapper bg-white movie-address">
                <p class="order-title">订单信息</p>
                <p class="order-info">订单编号：202103261443574892</p>
                <p class="order-info">下单时间：2021-03-26 14:34:25</p>
                <p class="order-info">电话号码：{{hiddenNumber(17718481442)}}</p>
            </div> -->

            <div class="movie-wrapper bg-white movie-address">
                <p class="order-title">身份信息</p>
                <div class="acea-row movie-viewer">
                    <div>观影人</div>
                    <ul>
                        <li>
                            <p><span class="name">张晓鱼</span><span class="phone">17718481442</span></p>
                            <p class="id">身份证：{{hiddenNumber(142601199906212526)}}</p>
                        </li>
                    </ul>
                </div>
            </div>

             <div class="movie-wrapper bg-white movie-address notice">
                 <p class="order-title">观影须知</p>
                 <p>1.请提前到达影院现场，找到自助取票机，打印纸质电影票，完成取票；</p>
                 <p>2.如现场自助取票机无法打印电影票，请联系影院工作人员处理；</p>
                 <p>3.凭打印好的纸质电影票，检票入场观影。</p>
             </div>

        </div>
   
        <!-- 立即付款 -->
      <MovieBottomButton :text="'确认订单'"  :goTo="{path:'/paymentResult'}"></MovieBottomButton>
   </div>
</template>

<script>
import MovieGoBack from "@components/MovieGoBack.vue";
import MovieBottomButton from "@components/MovieBottomButton.vue";

export default {
    name:"ConfirmOrder",
    components:{
        MovieGoBack,
        MovieBottomButton
    },

    data:function(){
        return {
            text:"确认订单",

        }
    },
    methods:{
        hiddenNumber:function(num){
            if(num) {
                let str = num + '';
                let arr = str.split('');
                let newArr = [];
                arr.forEach((item, ind)=>{
                    if(ind<3 || ind >= arr.length-4  ){
                        newArr.push(item);
                    } else {
                        newArr.push('*');
                    }
                })
                return newArr.join('');
            } else {
                return;
            }
        },

    }
}
</script>
<style scoped>
.confirm-order-top{
    width:100%;
    min-height:3.8rem;
    background-image:url('../../assets/images/movie_background.png');
    background-size: cover;
}
.order-detail-wrapper{
    box-sizing: border-box;
    padding:.4rem 0 .3rem .3rem;
    color:#fff;
}
.order-detail-wrapper p{
    margin:.1rem 0;
}
.order-detail-wrapper .title{
    display:flex;
    justify-content: space-between;
    margin-bottom:.2rem;
}
.order-detail-wrapper .title h1{
    font-size:.37rem;
    flex:1;
    font-weight: 400;
}
.order-detail-wrapper .title .time{
    height:.5rem;
    line-height:.5rem;
    padding:0 .3rem;
    background:rgba(255,255,255,0.3);
    border-radius:.3rem 0 0 .3rem;
    margin-left:.2rem;
}
.confirm-order-content{
    background:#f7f7f7;
    margin-bottom:1rem;
}
.bg-white{
    background:#fff;
}
.order-title{
    font-weight:600;
    color:#2c2c2c;
    font-size:.32rem;
    margin-bottom:.2rem;
}
.order-info{
    color:#959595;
    margin-bottom:.1rem;
}
.movie-address{
    padding-top:.2rem;
    padding-bottom:.2rem;
    margin-bottom:.2rem;
}
.phone{
    margin-left:.3rem;
}
.movie-viewer{
    margin-top:.3rem;
}
.movie-viewer div{
    margin-right:.5rem;
}
.movie-viewer ul{
    flex:1;
}
.movie-viewer ul li p{
    margin-bottom:.15rem;
}
p .phone{
    margin-left:.3rem;
}
.name{
    font-size:.3rem;
}
.id{
    font-size:.2rem;
}
.notice p{
    margin-bottom:.1rem;
    line-height: .4rem;
}
.not-support{
    margin-right:0.3rem;
}
.not{
    width: .3rem;
    height: .3rem;
    line-height: .3rem;
    color:#FF0B46;
    margin-right: .1rem;
    border: 0.01rem solid #FF0B46;
    border-radius: 50%;
}
</style>